<div  fxLayout="column" fxLayoutGap="20px">
  <span  fxLayout="row" fxLayoutAlign="center center" class="alert" ngStyle.xs="font-size:20px"> {{'confirmation' | transloco}}</span>
  <span fxLayout="column" fxLayoutGap="20px" >
    <span dir="auto" *ngIf="data?.fromAdminTemplate === undefined" fxFlex fxLayout="row" class="alertmsg" fxLayoutAlign="center center" ngStyle.xs="font-size:12px;padding-top:2px;padding-bottom:10px">{{'are_you_sure_you_want_to_check_out' | transloco}}</span>
    <span dir="auto" *ngIf="data?.fromAdminTemplate !== undefined" fxFlex fxLayout="row" class="alertmsg" fxLayoutAlign="center center" ngStyle.xs="font-size:12px;padding-top:2px;padding-bottom:10px">{{'are_you_sure_you_want_to_delete_this' | transloco}} {{data.message}}?</span>


    <div fxLayout="column" fxLayoutAlign="center center">
      <span fxLayoutGap="10px" fxLayout="row" >
        <div fxFlex="50" fxLayoutAlign="start ">
          <button color="#0014dc" ngStyle.xs="width:100px;font-size:15px;height:35px" mat-flat-button class="cancel-button medium" (click)="cancel()"
            >{{'cancel' | transloco}}</button>
        </div>
        <div fxFlex="50" fxLayoutAlign="end ">
          <button color="#0014dc" ngStyle.xs="width:100px;font-size:15px;height:35px"  mat-stroked-button class="ok-button medium" (click)="ok()">{{'ok' | transloco}}</button>
        </div>
      </span>
    </div>
  </span>

</div>
